import * as React from "react";
import PropTypes from "prop-types";
import NewsCard from "./NewsCard";

const NewsFeed = ({ gridItems }) => (
    <div className="">
        {gridItems.map((item) => (
            <NewsCard {...item} />
        ))}
    </div>
);

NewsFeed.propTypes = {
    gridItems: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
            content: PropTypes.string,
            date: PropTypes.string,
            heading: PropTypes.string,
            newsRelatedFile: PropTypes.string
        })
    ),
};

export default NewsFeed;
